import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-celeste/15 bg-abyss/40 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-38" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-39" data-mp="xt91jeypcq0k">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-40" data-mp="xs7gqirvwp5n">
          Basta improvvisare. <span className="text-celeste" data-id="element-41" data-mp="17qvlifuuz7re">Inizia a insegnare la meteorologia con chiarezza.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-42" data-mp="1li1rmusn83n9">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-celeste bg-ink/60 px-4 py-3 text-sm font-semibold text-white backdrop-blur-md" data-id="element-43" data-mp="1hj181a2ccwz7" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-celeste drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-44" data-mp="2cas355j3cyhw" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}